import React from 'react';
import ParentDocCard from '../../../common/ParentDocCard';
import DocsLink from '../../../../common/custom/DocsLink';
import VideoBox from '../../../../common/custom/VideoBox';

const FilterDoc = () => {
  return (
    <ParentDocCard>
      <h5>
        <b>Collection filters</b>
      </h5>
      <p>Allows you to apply customised filters in a collection to filter data entries.</p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/filters-in-collection" />
      <br />
      <h5>
        <b>Filter - Sum of Data</b>
      </h5>
      <p>Allows you to calculate the sum of data in a number field.</p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/sum-filter-in-collections" />
      <br />
      <h5>
        <b>Filter - Average of Data</b>
      </h5>
      <p>Allows you to calculate the average of data in a number field.</p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/average-filter-in-collections" />
      <br />
      <h5>
        <b>Filter - Maximum Value</b>
      </h5>
      <p>Allows you to filter and display data with the added maximum value in a number field.</p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/maximum-filter-in-collections" />
      <br />
      <h5>
        <b>Filter - Minimum Value</b>
      </h5>
      <p>Allows you to filter and display data with the added minimum value in a number field.</p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/minimum-filter-in-collections" />
      <br />
      <h5>
        <b>Filtered Items in Select Box Dropdown</b>
      </h5>
      <p>
        Allow you to limit the dropdown list to only show the items which match a certain condition
        or a list of filtered items/records of data in a Select dropdown box.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/filtered-items-in-select-box-dropdown#1-create-a-filter" />
      <br />
      <h5>
        <b>Working with Count Filters</b>
      </h5>
      <p>
        Allow you to implement count filters to get the count or no. of items in the collection
        matching some conditions.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/working-with-count-filters" />
      <br />

      <h5>
        <b>Displaying Filtered Data of Current Logged In User</b>
      </h5>
      <p>
        Allow you to display the data of current logged-in user in Data tables or Data Groups. Here
        data is meant for the logged-in user.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/displaying-filtered-data-of-current-logged-in-user" />
      <br />
      <h5>
        <b>External Parameters in Collection Filters</b>
      </h5>
      <p>
        Allow you to use external parameters in collection filters so that they can fetch data on
        the basis of dynamic values.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/external-parameters-in-collection-filters" />
      <br />
      <h5>
        <b>Filtering of Data with String or Number Comparison</b>
      </h5>
      <p>
        Allow you to filter and display the data in Data Table or Data Group on the basis of
        comparison of data with some fixed string or number.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-collection-filters/filtering-of-data-with-string-or-number-comparison" />
      <br />
      <br />
      <h5>
        <b>Videos</b>
      </h5>
      <VideoBox
        heading="Filter Data Conditions Example View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Filter+Data+Conditions+Example.jpg"
        videoLink="https://www.youtube.com/watch?v=IMnzqcSXSrM"
      />
      <br />
      <br />
      <VideoBox
        heading="Filtered Items in Select Box Dropdown View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Filtered+Items+in+Select+Box+Dropdown.jpg"
        videoLink="https://www.youtube.com/watch?v=alzI3mQ8egs"
      />
      <br />
      <br />
      <VideoBox
        heading="Working with Count Filters View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Working+with+Count+Filters.jpg"
        videoLink="https://www.youtube.com/watch?v=fVLAorsdwjQ"
      />
      <br />
      <br />
      <VideoBox
        heading="Displaying the Filtered Data of Current Logged In User View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Displaying+the+Filtered+Data+of+Current+Logged+In+User.jpg"
        videoLink="https://www.youtube.com/watch?v=auGkNwVrDi8"
      />
      <br />
      <br />
      <VideoBox
        heading="External Parameters in Collection Filters View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/External+Parameters+in+Collection+Filters.jpg"
        videoLink="https://www.youtube.com/watch?v=4tmVaG1WpRM"
      />
      <br />
      <br />
      <VideoBox
        heading="Filtering of Data with String or Number Comparison View Video"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Filtering+of+Data+with+String+or+Number+Comparison.jpg"
        videoLink="https://youtu.be/Mb0dVxoDPrY"
      />
    </ParentDocCard>
  );
};

export default FilterDoc;
